import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["field", "hiddenField"];

  connect() {
    fetch(this.fieldTarget.dataset.autocompletesrc)
      .then((response) => response.json())
      .then((data) => {
        this.initializeAutocomplete(data);
      });

    // Prevent enter from submitting the form when trying to select an item or have no results
    this.fieldTarget.addEventListener("keydown", (e) => {
      if (e.keyCode === 13) {
        e.preventDefault();
        return false;
      }
    });
  }

  initializeAutocomplete(data) {
    const _this = this
    this.fieldTarget.addEventListener("input", function () {
      const requestTerm = this.value;
      const results = data.filter((item) =>
        item.label.toLowerCase().includes(requestTerm.toLowerCase())
      );
      _this.handleResults(results.slice(0, 10));
    });
  }

  updateSelected (e) {
    const value = e.target.dataset.value
    const label = e.target.dataset.label
    this.fieldTarget.value = `${label}`
    this.hiddenFieldTarget.value = value

    this.closeDropdown();
  }

  closeDropdown () {
    document.querySelector('.autocomplete-backdrop').remove();
    document.querySelector('.autocomplete-form-dropdown').remove();

    if (this.fieldTarget.value == '') {
      this.hiddenFieldTarget.value = ''
    }
  }

  buildDropdownItem (item, dropdown) {
    const resultItem = document.createElement("div");
    resultItem.textContent = item.label;
    resultItem.classList.add('autocomplete-form-dropdown__element');
    resultItem.setAttribute('data-value', item.value)
    resultItem.setAttribute('data-label', item.label)
    resultItem.setAttribute('data-action', 'click->audit--organisation-autocomplete#updateSelected')
    dropdown.appendChild(resultItem);
  }

  handleResults(results) {
    const _this = this
    const dropwdownExists = document.querySelector('.autocomplete-form-dropdown') !== null;
    if (dropwdownExists) {
      this.closeDropdown()
    }
    
    const dropdownWrapper = document.createElement("div");
    dropdownWrapper.classList.add('autocomplete-backdrop');
    dropdownWrapper.setAttribute('data-action', 'click->audit--organisation-autocomplete#closeDropdown')
    this.fieldTarget.parentElement.appendChild(dropdownWrapper);
    const dropdown = document.createElement("div")
    dropdown.classList.add('autocomplete-form-dropdown');

    if (results.length === 0) {
      const noResultsItem = document.createElement("div");
      noResultsItem.textContent = "No results found";
      dropdown.appendChild(noResultsItem);
    } else {
      results.forEach((item) => {
        this.buildDropdownItem(item, dropdown)
      });
    }
    this.fieldTarget.parentElement.appendChild(dropdown);

  }
}
